import { TabsList, Tabs as TabsPrimitive, TabsTrigger } from '@/components/ui/tabs';

interface Option<T extends string> {
  value: T;
  label: React.ReactNode;
}

interface TabsProps<T extends string> {
  options: Option<T>[];
  defaultValue?: T;
  value?: T;
  onChange?: (value: T) => void;
  rootClassName?: string;
  listClassName?: string;
  triggerClassName?: string;
  children: React.ReactNode;
}

export function Tabs<T extends string>({
  options,
  defaultValue,
  value,
  onChange,
  rootClassName,
  listClassName,
  triggerClassName,
  children,
}: TabsProps<T>) {
  return (
    <TabsPrimitive
      defaultValue={defaultValue}
      value={value}
      onValueChange={(value) => onChange?.(value as T)}
      className={rootClassName}
    >
      <TabsList className={listClassName}>
        {options.map((option) => (
          <TabsTrigger key={option.value} value={option.value} className={triggerClassName}>
            {option.label}
          </TabsTrigger>
        ))}
      </TabsList>
      {children}
    </TabsPrimitive>
  );
}
